export type { TFirebaseUser } from '../firebase/database/schema'
export { getUserPath } from '../firebase/database/path'
